import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconComponent } from 'angular-tabler-icons';
import { ControlsModule } from 'src/app/controls/controls.module';

@Component({
  selector: 'app-test-widget',
  templateUrl: './test-widget.component.html',
  styleUrls: ['./test-widget.component.scss'],
  imports: [
    CommonModule,
    ControlsModule,
    TranslateModule,
    TablerIconComponent
  ]
})
export class TestWidgetComponent {
  @Input() examTemplate: any;
}
